// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.deno/css-loader@6.11.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.deno/css-loader@6.11.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SigmaWrapper-module__wrapper___JxjvA{margin:0 auto;width:72%;padding-bottom:130px}@media(max-width: 768px){.SigmaWrapper-module__wrapper___JxjvA{width:100%}}", "",{"version":3,"sources":["webpack://./src/containers/sigma/SigmaWrapper.module.scss"],"names":[],"mappings":"AAAA,sCACE,aAAA,CACA,SAAA,CACA,oBAAA,CAEA,yBALF,sCAMI,UAAA,CAAA","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": "SigmaWrapper-module__wrapper___JxjvA"
};
export default ___CSS_LOADER_EXPORT___;
